import Button from './Button'

const Feature = ({
  title,
  excerpt,
  ctaText,
  ctaLink,
  img,
  ctaExternal = false,
  order,
  small
}) => {
  return (
    <div className="relative bg-grey">
      <div className="lg:relative">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 ${
            order !== 'Imagen y Texto' ? '[direction:rtl]' : ''
          }`}
        >
          <div
            className={`relative w-full ${
              small ? 'h-64' : 'sm:h-72 md:h-96 lg:h-full'
            }`}
          >
            <img className="h-full w-full object-cover" src={img} alt="" />
          </div>
          <div
            className={`w-full text-center lg:text-left px-4 sm:px-8 lg:pl-24 lg:pr-24 ${
              small
                ? 'flex flex-col justify-center py-5 lg:py-0'
                : 'py-20 lg:pt-36 lg:py-48'
            }`}
          >
            <h1 className="text-4xl font-alliance-medium tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
              <span className="block xl:inline">{title}</span>
            </h1>
            <p className="mx-auto mt-3 font-alliance-light max-w-md text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
              {excerpt}
            </p>
            {ctaText && (
              <div className="mt-10 sm:justify-center lg:justify-start">
                <Button
                  link={ctaLink}
                  text={ctaText}
                  target={ctaExternal ? '_blank' : '_self'}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Feature
